/*
 * サブシステム名：受注契約
 * 機能名：受注契約入力画面
 */

import DdSubHeader from '@/components/DdSubHeader'
import DdTextBox from '@/components/DdTextBox'
import DdDateBox from '@/components/DdDateBox'
import DdNumericBox from '@/components/DdNumericBox'
import DdFooterButton from '@/components/DdFooterButton'
import DdCodeTextBox from '@/components/DdCodeTextBox.vue'
import DdRadioButton from '@/components/DdRadioButton'
import DdCheckbox from '@/components/DdCheckbox'
import DdDefaultButton from '@/components/DdDefaultButton'
import DdJuchuKeiyakuKensakuTextBoxByKeiyakuEdit from '@/components/DdJuchuKeiyakuKensakuTextBoxByKeiyakuEdit'
import DdJuchuListDialog from '@/components/DdJuchuListDialog'

import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'
import message from '@/ddv2.library/messages'
import header from '@/ddv2.library/header'
import modals from '@/ddv2.library/modals'

export default {
  name: 'JuchuKeiyakuEdit',
  mixins: [flowMixin],
  data: () => ({
    id: 0,
    rec: {},
    invalidMessages: {},
    headersEigyoshoList: header.mstEigyoshoHeaders,
    headersSeikyusakiList: header.mstTorihikisakiHeaders,
    juchuKeiyakuId: 0,
    juchuListDialog: false,
    modeOfEdit: 5,
    modeKengen: 2,
    isReadonlyMode1: false,
    isReadonlyMode2: false,
    isReadonlyMode3: false,
    isJuchuListDialogButtonDisplay: false,
    isCancelButtonDisplay: false,
    isDeleteButtonDisplay: false,
    isCreateButtonDisplay: false,
    isCopyButtonDisplay: false,
    isCreateContinuingButtonDisplay: false,
    isSaveButtonDisplay: false
  }),
  components: {
    DdJuchuKeiyakuKensakuTextBoxByKeiyakuEdit,
    DdJuchuListDialog,
    DdSubHeader,
    DdTextBox,
    DdDateBox,
    DdNumericBox,
    DdCodeTextBox,
    DdFooterButton,
    DdRadioButton,
    DdCheckbox,
    DdDefaultButton
  },
  computed: {
    ...mapGetters({
      eigyoshoList: 'DDMasters/mstEigyosho',
      torihikisakiList: 'DDMasters/vwCMstTorihikisakiGetSeikyusaki',
      addressList: 'DDMasters/mstAddress',
      kubunList: 'DDMasters/msysKubun',
      kihonJohoList: 'DDMasters/mstKihonJoho',
      eigyoshoLockFlg: 'users/anotherEigyoshoCtrlFlg',
      userEigyoshoCd: 'users/eigyoshoCd'
    }),
    eigyoshoReadOnly () {
      const self = this
      return !self.eigyoshoLockFlg
    },
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.eigyoshoCd > elem2.eigyoshoCd) { return 1 }
        if (elem1.eigyoshoCd === elem2.eigyoshoCd) { return 0 }
        return -1
      })
    },
    filteredSeikyusakiList () {
      // 請求先で絞り込む
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },
    filteredAddressList () {
      return this.addressList
    },
    filteredSeikyuKeijoTaniKbn () {
      return this.kubunList.filter(function (elem) {
        return elem.kbnShuruiCd === 'KBN009'
      }).map(function (elem) {
        elem.value = elem.code
        elem.text = elem.codeNm
        return elem
      })
    },
    calcSuryoIntegerDigit () {
      if (this.kihonJohoList && this.kihonJohoList[0] && this.kihonJohoList[0].suryoNumericLen) {
        return this.kihonJohoList[0].suryoNumericLen
      } else {
        return 10
      }
    },
    calcSuryoMinorDigit () {
      if (this.kihonJohoList && this.kihonJohoList[0] && this.kihonJohoList[0].suryoDecimalLen) {
        return this.kihonJohoList[0].suryoDecimalLen
      } else {
        return 4
      }
    },
    calcSuryoMax () {
      return Math.pow(10, this.calcSuryoIntegerDigit) - Math.pow(10, -1 * this.calcSuryoMinorDigit)
    },
    calcJuryoIntegerDigit () {
      if (this.kihonJohoList && this.kihonJohoList[0] && this.kihonJohoList[0].juryoNumericLen) {
        return this.kihonJohoList[0].juryoNumericLen
      } else {
        return 10
      }
    },
    calcJuryoMinorDigit () {
      if (this.kihonJohoList && this.kihonJohoList[0] && this.kihonJohoList[0].juryoDecimalLen) {
        return this.kihonJohoList[0].juryoDecimalLen
      } else {
        return 4
      }
    },
    calcJuryoMax () {
      return Math.pow(10, this.calcJuryoIntegerDigit) - Math.pow(10, -1 * this.calcJuryoMinorDigit)
    }
  },
  created () {
    this.id = this.$route.params.id
    if (this.id === '0') {
      this.id = 0
    }
  },
  mounted () {
    this.initialize()
  },
  methods: {
    setKeiyakuEndYmdString: function () {
      if (this.rec.keiyakuStartYmdString === undefined || this.rec.keiyakuKikanTsukisu === undefined) { return }
      if (this.rec.keiyakuStartYmdString.length !== 0 && this.rec.keiyakuKikanTsukisu.length !== 0) {
        var dt = new Date(this.rec.keiyakuStartYmdString)
        // 計算前日付
        var beforeDate = dt.getDate()
        dt.setMonth(dt.getMonth() + Number(this.rec.keiyakuKikanTsukisu))
        if (dt.getDate() !== beforeDate) {
          // 計算後日付が一致しない場合、前月月末指定
          this.rec.keiyakuEndYmdString = filter.dateFormatter(dt.setDate(0))
        } else {
          this.rec.keiyakuEndYmdString = filter.dateFormatter(dt)
        }
      } else {
        this.rec.keiyakuEndYmdString = ''
      }
    },
    setSeikyusakiData: function () {
      var torihikisaki = this.filteredSeikyusakiList.find(({ torihikisakiCd }) => torihikisakiCd === this.rec.seikyusakiCd)
      if (torihikisaki === undefined) { return }
      this.HttpClient
        .get(`/api/v1/MstNyukinsaki/FindByTorihikisakiId?id=${torihikisaki.id}`)
        .then((data) => {
          var seikyusaki = data.payload

          if (seikyusaki) {
            var address = this.filteredAddressList.find(({ id }) => id === seikyusaki.renrakusakiAddressId)
            if (address === undefined) { return }
            if (this.rec.seikyusakiTelNo.length === 0) {
              this.rec.seikyusakiTelNo = address.telNo
            }
            if (this.rec.seikyusakiTantosha.length === 0) {
              this.rec.seikyusakiTantosha = address.tantoshaNm
            }
            if (this.rec.seikyusakiMailAddress.length === 0) {
              this.rec.seikyusakiMailAddress = address.mailAddress
            }
          }
        })
    },
    setEigyoshoCd: function (eigyoshoId) {
      var eigyosho = this.filteredEigyoshoList.find(({ id }) => id === eigyoshoId)
      if (eigyosho !== undefined) {
        return eigyosho.eigyoshoCd
      }
      return ''
    },
    setSeikyusakiCd: function (seikyusakiId) {
      var seikyusaki = this.filteredSeikyusakiList.find(({ id }) => id === seikyusakiId)
      if (seikyusaki !== undefined) {
        return seikyusaki.torihikisakiCd
      }
      return ''
    },
    setEigyoshoId: function (pEigyoshoCd) {
      var eigyosho = this.filteredEigyoshoList.find(({ eigyoshoCd }) => eigyoshoCd === pEigyoshoCd)
      if (eigyosho !== undefined) {
        return eigyosho.id
      }
      return -1
    },
    setSeikyusakiId: function (pSeikyusakiCd) {
      var seikyusaki = this.filteredSeikyusakiList.find(({ torihikisakiCd }) => torihikisakiCd === pSeikyusakiCd)
      if (seikyusaki !== undefined) {
        return seikyusaki.id
      }
      return -1
    },
    getCloneTargetMethod: function () {
      return this.rec
    },
    beforeRouteLeaveByMenu: function (next) {
      const opt = {
        nextCallback: next
      }

      this.preventTransition(opt)
    },
    fetchData: function () {
      console.log('fetchData')
      const self = this
      // this.rec = {}
      return new Promise((resolve) => {
        self.HttpClient
          .get(`/api/v1/TrJuchuKeiyaku/find?id=${self.id}`)
          .then((data) => {
            self.rec = data.payload
            // 日付項目を削除（日付文字列化項目を使用）
            delete self.rec.keiyakuStartYmd
            delete self.rec.keiyakuEndYmd
            delete self.rec.juchuKeiyakuYmd
            // IDからコードを設定（表示項目）
            self.rec.eigyoshoCd = self.setEigyoshoCd(data.payload.juchuKeiyakuEigyoshoId)
            self.rec.seikyusakiCd = self.setSeikyusakiCd(data.payload.seikyusakiId)

            resolve()
          })
      }).then(() => {
        // 次契約データ存在確認
        return new Promise((resolve) => {
          this.HttpClient
            .get(`/api/v1/VwCD2orcd0010/findById?id=${this.id}`)
            .then((data) => {
              if (data.payload.jidoKeizokuData === '作成済') {
                this.keizokuDataFlg = true
              }
              resolve()
            })
        })
      }).then(() => {
        return new Promise((resolve) => {
          // 紐づけデータ存在確認
          this.HttpClient
            .post('/api/v1/VwCD2orcd0011/search', { juchuKeiyakuId: this.rec.id })
            .then((data) => {
              if (data.payload.length !== 0) {
                this.relationDataFlg = true
              }
              resolve()
            })
        })
      })
    },
    initialize () {
      const self = this
      const option = {
        loadMasters: ['msteigyosho', 'vwcmsttorihikisakigetseikyusaki', 'mstaddress', 'msyskubun', 'mstkihonjoho'],
        initializeInputPromise: () => {
          return new Promise((resolve) => {
            // システム日付
            self.processYmdString = filter.dateFormatter(new Date())
            self.keizokuDataFlg = false
            self.relationDataFlg = false
            self.rec = {
              eigyoshoCd: !self.eigyoshoLockFlg ? self.userEigyoshoCd : '',
              seikyusakiCd: '',
              seikyusakiTelNo: '',
              seikyusakiTantosha: '',
              seikyusakiMailAddress: '',
              juchuKeiyakuYmdString: self.processYmdString,
              keiyakuStartYmdString: self.processYmdString,
              jidoKeizokuFlg: false,
              seikyuKeijoTaniKbn: '1'
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          return new Promise((resolve) => {
            console.log('★savedInputRestorePromise', c)
            console.log('★savedInputRestorePromise', self.rec)
            // ユーザ保存項目の復元
            self.rec = { ...self.rec, ...c }
            console.log('★savedInputRestorePromise', self.rec)
            resolve()
          })
        },
        existsIdMethod: () => {
          return self.id !== 0
        },
        requestApiPromise: self.fetchData,
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            console.log('★★★settingButtonStatePromise★★★')
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            if (self.id === 0) {
              // 新規モード
              self.modeOfEdit = 0
            } else if (self.modeKengen === 0) {
              // 照会モード
              self.modeOfEdit = 1
            } else if (self.rec.keiyakuEndYmdString < self.processYmdString && self.rec.jidoKeizokuFlg === false) {
              // 更新４：更新モードかつ契約満了日＜処理日かつ自動契約フラグがfalse
              self.modeOfEdit = 5
            } else if (self.rec.keiyakuEndYmdString < self.processYmdString && self.keizokuDataFlg === true) {
              // 更新３：更新モードかつ契約満了日＜処理日かつ次契約データ存在
              self.modeOfEdit = 4
            } else if (self.rec.keiyakuEndYmdString < self.processYmdString) {
              // 更新２：更新モードかつ契約満了日＜処理日
              self.modeOfEdit = 3
            } else {
              // 更新１：更新モードかつ契約満了日＞＝処理日（上記以外）
              self.modeOfEdit = 2
            }

            if (self.modeOfEdit !== 0) {
              self.isJuchuListDialogButtonDisplay = true
            }
            if (self.modeKengen !== 0 && (self.modeOfEdit !== 1 && self.modeOfEdit !== 2)) {
              self.isCancelButtonDisplay = true
            }
            if (self.modeKengen === 2 && (self.modeOfEdit === 3 || self.modeOfEdit === 4 || self.modeOfEdit === 5) && self.relationDataFlg !== true) {
              self.isDeleteButtonDisplay = true
            }
            if (self.modeKengen !== 0 && (self.modeOfEdit === 3 || self.modeOfEdit === 4 || self.modeOfEdit === 5)) {
              self.isCreateButtonDisplay = true
            }
            if (self.modeKengen !== 0 && self.modeOfEdit !== 0 && self.modeOfEdit !== 1) {
              self.isCopyButtonDisplay = true
            }
            if (self.modeKengen !== 0 && self.modeOfEdit === 3) {
              self.isCreateContinuingButtonDisplay = true
            }
            if (self.modeKengen !== 0 && (self.modeOfEdit !== 1 && self.modeOfEdit !== 2)) {
              self.isSaveButtonDisplay = true
            }

            resolve()
          })
        },
        settingItemMethod: (kengen) => {
          console.log('settingItemMethod', kengen)
          if (self.modeOfEdit !== 0) {
            self.isReadonlyMode1 = true
          }
          if (self.modeOfEdit !== 0) {
            self.isReadonlyMode2 = true
          }
          if (self.modeOfEdit === 1 || self.modeOfEdit === 2) {
            self.isReadonlyMode3 = true
          }
        }
      }
      console.info('call initializeForRegister', this.initializeForRegister, option)
      this.initializeForRegister(option)
    },
    onJuchuListDialogOpen: function () {
      this.juchuKeiyakuId = this.rec.id
      this.juchuListDialog = true
    },
    onJuchuListDialoClose: function (e) {
      this.juchuListDialog = false
    },
    onReturnButtonClick: function (e) {
      console.log('onReturnButtonClick', e)
      const self = this
      const opt = {
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        }
      }

      this.transitionBack(opt)
    },
    onCancelButtonClick: function (e) {
      console.log('onCancelButtonClick', e)
      const self = this
      const opt = {
        restoreInputsPromise: function (data) {
          return new Promise(resolve => {
            console.log('■restoreInputsPromise', data())
            self.rec = data()
            self.rec.id = self.id
            resolve()
          })
        }
      }

      this.cancelInputs(opt)
    },
    onDeleteButtonClick: function (e) {
      const self = this
      const opt = {
        deleteRequestPromise: function () {
          return new Promise(resolve => {
            self.rec = self.cloneData
            self.rec.delFlg = true
            self.HttpClient.put(`/api/v1/TrJuchuKeiyaku/Update?id=${self.id}`, self.rec).then(data => {
              resolve(data)
            })
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        }
      }
      this.delete(opt)
    },
    onCreateButtonClick: function (e) {
      const self = this
      const p = modals.showConfirm
      p('COMQ0006').then((ok) => {
        if (ok === false || ok === undefined) { return }
        self.id = 0
        self.rec.id = 0
        self.rec.juchuKeiyakuNo = ''
        self.modeOfEdit = 0
        self.isReadonlyMode1 = false
        self.isReadonlyMode2 = false
        self.isReadonlyMode3 = false
        self.isJuchuListDialogButtonDisplay = false
        self.isCancelButtonDisplay = true
        self.isDeleteButtonDisplay = false
        self.isCreateButtonDisplay = false
        self.isCopyButtonDisplay = false
        self.isCreateContinuingButtonDisplay = false
        self.isSaveButtonDisplay = true

        self.transition(1, { id: 0 }, self.initialize)
      })
    },
    onCopyButtonClick: function (e) {
      const self = this
      const opt = {
        setIdMethod: () => {
          self.id = 0
          self.rec.id = 0
          self.rec.juchuKeiyakuNo = ''
          self.modeOfEdit = 0
          self.isReadonlyMode1 = false
          self.isReadonlyMode2 = false
          self.isReadonlyMode3 = false
          self.isJuchuListDialogButtonDisplay = false
          self.isCancelButtonDisplay = true
          self.isDeleteButtonDisplay = false
          self.isCreateButtonDisplay = false
          self.isCopyButtonDisplay = false
          self.isCreateContinuingButtonDisplay = false
          self.isSaveButtonDisplay = true
          // クローンデータ上書き（キャンセル実行時に複写元のデータの契約番号に上書かれるのを防ぐ）
          self.cloneData = JSON.parse(JSON.stringify(self.rec))
          console.log('clear id', self.rec)
        }
      }
      this.copyInputs(opt)
    },
    onCreateContinuingButtonClick: function (e) {
      const self = this
      const opt = {
        registerRequestPromise: self.registerPromiseCreateContinuing,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.id = data.payload.id
            resolve()
          })
        },
        getIdMethod: () => {
          return self.id
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            self.id = id
            self.transition(1, { id: id }, self.initialize)
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        isUpdateModeMethod: function () {
          return self.id !== 0
        },
        getSavedInputMethod: function () {
          return {}
        }
      }

      this.register(opt)
    },
    onSaveButtonClick: function (e) {
      const self = this
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.id = data.payload.id
            resolve()
          })
        },
        getIdMethod: () => {
          return self.id
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            self.id = id
            self.rec.id = id
            self.rec.juchuKeiyakuNo = ''
            self.modeOfEdit = 0
            self.isReadonlyMode1 = false
            self.isReadonlyMode2 = false
            self.isReadonlyMode3 = false
            self.isJuchuListDialogButtonDisplay = false
            self.isCancelButtonDisplay = true
            self.isDeleteButtonDisplay = false
            self.isCreateButtonDisplay = false
            self.isCopyButtonDisplay = false
            self.isCreateContinuingButtonDisplay = false
            self.isSaveButtonDisplay = true
            self.transition(1, { id: id }, self.initialize)
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        isUpdateModeMethod: function () {
          return self.id !== 0
        },
        getSavedInputMethod: function () {
          return {}
        }
      }

      this.register(opt)
    },
    registerPromise: function () {
      let f
      // コードからIDを設定
      this.rec.juchuKeiyakuEigyoshoId = this.setEigyoshoId(this.rec.eigyoshoCd)
      this.rec.seikyusakiId = this.setSeikyusakiId(this.rec.seikyusakiCd)
      if (this.id === 0) {
        f = this.HttpClient.post('/api/v1/TrJuchuKeiyaku/CreateWithSaiban', this.rec)
      } else {
        f = this.HttpClient.put(`/api/v1/TrJuchuKeiyaku/Update?id=${this.id}`, this.rec)
      }
      return f
    },
    registerPromiseCreateContinuing: function () {
      var f
      f = this.HttpClient.put(`/api/v1/TrJuchuKeiyaku/CreateContinuing?id=${this.id}`)
      return f
    },
    registerValidate: function () {
      if (this.id !== 0 && this.cloneData.juchuKeiyakuNo !== this.rec.juchuKeiyakuNo) {
        this.$refs.juchuKeiyakuNo[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0121', ['契約番号']))
        this.setInvalidSummaryMessage('COME0015')
        return false
      }
      return true
    },
    deleteValidate: function () {
      if (this.cloneData.juchuKeiyakuNo !== this.rec.juchuKeiyakuNo) {
        this.$refs.juchuKeiyakuNo[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0121', ['契約番号']))
        this.setInvalidSummaryMessage('COME0015')
        return false
      }
      return true
    },
    changeJuchuKeiyakuNo: function (id) {
      const self = this
      return new Promise(resolve => {
        self.id = id
        self.rec.id = id
        self.rec.juchuKeiyakuNo = ''
        self.modeOfEdit = 0
        self.isReadonlyMode1 = false
        self.isReadonlyMode2 = false
        self.isReadonlyMode3 = false
        self.isJuchuListDialogButtonDisplay = false
        self.isCancelButtonDisplay = false
        self.isDeleteButtonDisplay = false
        self.isCreateButtonDisplay = false
        self.isCopyButtonDisplay = false
        self.isCreateContinuingButtonDisplay = false
        self.isSaveButtonDisplay = false
        self.transition(1, { id: id }, self.initialize)
        resolve()
      })
    }
  }
}
